export default __webpack_public_path__ + "static/media/WhatsApp Image 2022-05-18 at 12.51.25.929bde7b.jpeg";